import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class EgresadoFotoService {
  private userPhoto = new BehaviorSubject<string>(null);

  constructor() { }

  setUserPhoto(photo: string) {
    if(photo && photo!='')
      this.userPhoto.next('https://res.cloudinary.com/drtcnv1st/image/upload/w_1000,c_fill,ar_1:1,g_auto,r_max,bo_5px_solid_red,b_rgb:262c35/v1677881047/Graduados/'+photo);
    else
      this.userPhoto.next('https://res.cloudinary.com/drtcnv1st/image/upload/w_1000,c_fill,ar_1:1,g_auto,r_max,bo_5px_solid_red,b_rgb:262c35/v1677881047/Graduados/No_image_available.svg_xvejcl.png');
  }

  getUserPhoto() {
    return this.userPhoto.asObservable();
  }
}